module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/products/products.component.css
// module id = ./src/app/pages/products/products.component.css
// module chunks = main